module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_01-0188fd64d7095bcf2b639c18a1c48db8.jpg";